import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useUserCardProvider } from '../../../../../utilities/sharedHooks/user';
import { cardProviders } from '../../../../../screens/Card/constants';

const MAPPING = {
  [cardProviders.MONAVATE]: {
    x: 32,
    y: 165,
    fontSize: 15.27,
    fontWeight: 500,
  },
  [cardProviders.GALILEO]: {
    x: 30,
    y: 170,
    fontSize: 15.27,
    fontWeight: 500,
    fontFamily: 'HM Alpha Mono',
  },
};
export const ValidUntilDate = ({ cardValidThrough = null }) => {
  const { cardProvider } = useUserCardProvider();
  const {
    x = 45,
    y = 130,
    fontSize = 16,
    fontWeight = 'bold',
    fontFamily = 'Open Sans',
  } = MAPPING[cardProvider] || {};

  const validUntilDate = useMemo(() => {
    if (cardValidThrough) {
      if (cardProvider === cardProviders.MONAVATE) {
        const date = cardValidThrough.split('/');
        const month = date?.length > 0 ? date[1] : '00';
        const year = date?.length > 0 ? date[0].slice(2, 4) : '00';

        return `${month}/${year}`;
      }
      return `${cardValidThrough?.slice(0, 2)}/${cardValidThrough?.slice(2, 4)}`;
    }
    return '00/00';
  }, [cardProvider, cardValidThrough]);

  if (validUntilDate) {
    return (
      <g>
        <text
          fill="#142633"
          fontWeight={fontWeight}
          fontSize={fontSize}
          fontFamily={fontFamily}
          x={x}
          y={y}>
          {validUntilDate}
        </text>
      </g>
    );
  }
  return <></>;
};
ValidUntilDate.propTypes = {
  cardValidThrough: PropTypes.string,
};
export default ValidUntilDate;
